import config from "./app.config.js";
import "core-js/stable";
import "regenerator-runtime/runtime";
// import './registerServiceWorker'
import "whatwg-fetch";
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import { EventBus } from "@/assets/js/event-bus.js";
import envivo from "@envivo/backoffice-components";
import $lang from "@/assets/js/lang.js";
import helpers from "@/assets/js/helpers.js";
import moment from "moment-timezone";
import VeeValidate, { Validator } from "vee-validate";
import VueI18n from "vue-i18n";
import VModal from "vue-js-modal";
import Snotify, { SnotifyPosition } from "vue-snotify";
import "vue-snotify/styles/simple.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";
import "@envivo/backoffice-theme/scss/fonts.scss";
import "@envivo/backoffice-theme/scss/main.scss";
import VueBrowserUpdate from "@sum.cumo/vue-browserupdate";
import { Base64 } from "js-base64";

// import static icon not used by icon component
import successIcon from "@/assets/svg/icons/v2-toast-success.svg";
import errorIcon from "@/assets/svg/icons/v2-toast-error.svg";
import warningIcon from "@/assets/svg/icons/v2-toast-warning.svg";
import infoIcon from "@/assets/svg/icons/v2-toast-info.svg";
import simpleIcon from "@/assets/svg/icons/v2-toast-simple.svg";

import "vue-awesome/icons/check";
import "vue-awesome/icons/eye";
import "vue-awesome/icons/eye-slash";
import "vue-awesome/icons/download";
import "vue-awesome/icons/times";

import Icon from "vue-awesome/components/Icon";
import $auth from "@/assets/js/auth";

require("@/assets/js/redactor.js");
const VueScrollTo = require("vue-scrollto");

// change appversion to reset vuex persisted states on deployment
const appVersion = 52;

// disable check for new version because the new version is the default version now
/*
if (config.switchVersion.canSwitch) {
  const active = localStorage.getItem("newVersionActive");
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const redirectedFromNewVersion = params.has("redirectedFromNewVersion");
  if (active === "isActive" && !redirectedFromNewVersion) {
    helpers.toggleVersion();
  } else {
    const url = helpers.removeURLParameter(
      window.location.href,
      "redirectedFromNewVersion"
    );
    window.history.pushState("", "", url);
    localStorage.removeItem("newVersionActive");
  }
}
*/

Vue.config.productionTip = false;
Vue.use(envivo, { eventbus: EventBus });
Vue.use(VModal);
Vue.use(Snotify, {
  toast: {
    timeout: 4000,
    showProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    position: SnotifyPosition.rightTop,
  },
});

Vue.use(VeeValidate, {
  events: "",
});
Vue.use(VueI18n);
if (process.env.NODE_ENV !== "production") {
  Object.keys(envivo.translations).forEach((k) => {
    if (k !== "dev") {
      helpers.mergeDeep(envivo.translations[k], envivo.translations.dev);
    }
  });
}
Vue.component("v2-awesome-icon", Icon);

const i18n = new VueI18n({
  locale: "de",
  fallbackLocale: "en",
  messages: envivo.translations,
  silentFallbackWarn: true,
});
export { i18n };
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
Vue.prototype.$base64 = Base64;
Vue.prototype.$config = config;
Vue.prototype.$eventbus = EventBus;
Vue.prototype.$h = helpers;
Vue.prototype.$goTo = helpers.goTo;
Vue.prototype.$moment = moment;
Vue.prototype.$errorIcon = errorIcon;
Vue.prototype.$successIcon = successIcon;
Vue.prototype.$warningIcon = warningIcon;
Vue.prototype.$infoIcon = infoIcon;
Vue.prototype.$simpleIcon = simpleIcon;
Vue.prototype.$initLocale = (lang) => {
  const locales = $lang.availableLocales;
  const defaultLocale = "en";
  let appLocale = "";
  for (let i = 0; i < locales.length; i += 1) {
    if (lang === locales[i]) {
      appLocale = lang;
      break;
    } else {
      appLocale = defaultLocale;
    }
  }
  Validator.localize(appLocale, envivo.translations[appLocale].veeValidate);
  Vue.prototype.$moment.locale(appLocale);
  i18n.locale = appLocale;
  i18n.fallbackLocale = defaultLocale;

  let readingDirection = "ltr";
  if (appLocale === "he") {
    readingDirection = "rtl";
  }
  let htmlEl = document.querySelector("html");
  htmlEl.setAttribute("dir", readingDirection);
};

Vue.use(VueBrowserUpdate, {
  options: {
    container: document.body,
    required: { i: 0, f: 0, o: 0, s: 0, c: 0 },
    reminderClosed: 24,
    no_permanent_hide: true,
  },
});

const globalData = new Vue({
  data: { $windowWidth: 0 },
});
Vue.mixin({
  computed: {
    $windowWidth: {
      get: function () {
        return globalData.$data.$windowWidth;
      },
      set: function (width) {
        globalData.$data.$windowWidth = width;
      },
    },
  },
});

// <!-- Sendinblue Conversations {literal} -->
(function (d, w, c) {
  w.SibConversationsID = "5cb5fb9acc7f32af6d7f1514";
  w[c] =
    w[c] ||
    function () {
      (w[c].q = w[c].q || []).push(arguments);
    };
  const s = d.createElement("script");
  s.async = true;
  s.src = "https://conversations-widget.sendinblue.com/sib-conversations.js";
  if (d.head) d.head.appendChild(s);
})(document, window, "SibConversations");
// <!-- /Sendinblue Conversations {/literal} -->

// set app language
let browserLocale = window.navigator.userLanguage || window.navigator.language;
browserLocale = browserLocale.substr(0, 2);
Vue.prototype.$initLocale(browserLocale);

// check app version
console.log("store version", store.getters.global_get_version);
console.log("app version", appVersion);
if (store.getters.global_get_version !== appVersion) {
  console.log("reset storage");
  localStorage.removeItem("localStorageEnvivo");
  sessionStorage.removeItem("sessionStorageEnvivo");
  store.commit("AUTH_RESET_AUTH");
  store.commit("GLOBAL_RESET_STORE");
  store.commit("GLOBAL_SET_VERSION", appVersion);
}

// check if team is set by api env
const team = config.team;
if (team && team.id) {
  Vue.prototype.$initLocale(config.locale);
  store.commit("AUTH_SET_TEAM", {
    uid: team.id,
    slug: team.slug,
    name: team.name,
  });
  store.commit("AUTH_SET_COGNITO", {
    slug: team.slug,
    cognito: team.auth.cognito,
  });
  store.commit("AUTH_SET_API", { slug: team.slug, api: team.api });
  let storageObject = JSON.parse(localStorage.getItem("localStorageEnvivo"));
  if (!storageObject) storageObject = {};
  storageObject[team.slug] = "false";
  localStorage.setItem("localStorageEnvivo", JSON.stringify(storageObject));
  router.push("/" + team.slug);
}

// listen for changes to localStorage
if (window.addEventListener) {
  window.addEventListener(
    "storage",
    (e) => {
      helpers.sessionStorageTransfer(e);
    },
    false
  );
} else {
  window.attachEvent("onstorage", (e) => {
    helpers.sessionStorageTransfer(e);
  });
}
// do stuff before window unload
window.onbeforeunload = function (event) {
  console.log("window onbeforeunload");
  if (
    router.currentRoute.params.team &&
    store.getters.global_get_teams_settings[router.currentRoute.params.team].unsavedChanges
  ) {
    event.returnValue = i18n.t("app.confirmLeaving");
  }
  if (router.currentRoute.params.team) {
    store.commit("GLOBAL_SET_PUSHER_INIT", {
      teamUid: router.currentRoute.params.team,
      state: false,
    });
  }
  localStorage.removeItem("localStorageEnvivo");
  return undefined;
};
window.onunload = function () {
  console.log("window onunload");
  store.commit("GLOBAL_SET_UNSAVED_CHANGES", { val: false });
};

// init app
function init(teamUid) {
  // set app lang
  if (store.getters.auth_get_teams[teamUid] && store.getters.auth_get_teams[teamUid].account) {
    Vue.prototype.$initLocale(store.getters.auth_get_teams[teamUid].account.locale);
    Vue.prototype.$eventbus.$emit("refreshAppData", teamUid);
  }
  // reset nav state
  store.commit("GLOBAL_RESET_SEARCHOBJECT");
}

router.beforeEach((to, from, next) => {
  console.log("### TO", to);
  document.title = "envivo";
  // ### CREATE SESSION FROM QUERY TOKENS ###
  const createSessionFromTokens = new Promise((resolve, reject) => {
    if (to.query.accessToken && to.query.idToken && to.query.refreshToken && to.query.username) {
      if (to.params.teamSlug) {
        store
          .dispatch("getTeamBySlug", { slug: to.params.teamSlug })
          .then((res) => {
            console.log("##### getTeamBySlug", res);
            const data = {
              UserPoolId: res.data.data.auth.cognito.pool_id,
              ClientId: res.data.data.auth.cognito.client_id,
              username: to.query.username,
              tokens: {
                accessToken: to.query.accessToken,
                idToken: to.query.idToken,
                refreshToken: to.query.refreshToken,
              },
            };
            $auth
              .createSessionFromTokens(data)
              .then((session) => {
                console.log(session);
                store.commit("AUTH_SET_AUTHENTICATED", {
                  uid: res.data.data.uid,
                  token: session.accessToken.jwtToken,
                  username: session.accessToken.payload.username,
                });
                const p1 = store.dispatch("getAuthAccount", { team: res.data.data.uid }).then((account) => {
                  Vue.prototype.$initLocale(account.locale);
                });
                const p2 = store.dispatch("initGlobalTeamSettings", res.data.data.uid);
                Vue.prototype.$eventbus.$emit("setProfileDropdown", res.data.data.uid);
                console.log("##### session is valid");
                Promise.all([p1, p2]).finally(() => {
                  if (to.query.redirectUrl) {
                    window.location.href = to.query.redirectUrl;
                  } else {
                    next("/t/" + res.data.data.uid + "/dashboard");
                  }
                });
              })
              .catch((err) => {
                console.log("##### session is NOT valid", err);
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
  createSessionFromTokens.finally(() => {
    // ### HANDLE REMEMBER SESSION ###
    // get sessionstorage & localestorage
    let session = JSON.parse(sessionStorage.getItem("sessionStorageEnvivo"));
    let localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
    let rememberMe = JSON.parse(localStorage.getItem("rememberMeEnvivo"));
    console.log(
      "### CHECK SESSION - sessionstorage:",
      session,
      " - localstorage:",
      localSession,
      " - Auth teams:",
      store.getters.auth_get_teams
    );
    // get team id from url or store
    const team = to.params.teamSlug
      ? helpers.getTeamObjectBySlug(store.getters.auth_get_teams, to.params.teamSlug)
      : null;
    const teamUid = to.params.team ? to.params.team : team && team.team ? team.team.uid : null;
    console.log("### TEAM UID", teamUid, team, to.params.team, to.params.teamSlug);

    // set localstorage from sessionstorage if session exists
    if (session !== null && session[teamUid]) {
      const storageData = Object.assign({}, session, localSession);
      console.log("### SET LOCALSTORAGE", storageData);
      localStorage.setItem("localStorageEnvivo", JSON.stringify(storageData));
    }
    // set sessionstorage from localstorage if session does not exist
    if (session === null && localSession && localSession[teamUid]) {
      console.log("### SET SESSIONSTORAGE", localSession);
      sessionStorage.setItem("sessionStorageEnvivo", JSON.stringify(localSession));
    }
    // get sessionstorage & localestorage again
    session = JSON.parse(sessionStorage.getItem("sessionStorageEnvivo"));
    localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
    console.log(
      "### CHECK SESSION after storage resetting - sessionstorage:",
      session,
      " - localstorage:",
      localSession
    );
    // logout & reset teamsettings
    Object.keys(store.getters.auth_get_teams).forEach((key) => {
      if (key !== "default") {
        console.log(
          "***** DEBUG ***** CHECK",
          session === null &&
            localSession === null &&
            ((rememberMe && rememberMe[key] && rememberMe[key] === "false") ||
              (rememberMe && typeof rememberMe[key] === "undefined"))
        );
        if (
          session === null &&
          localSession === null &&
          ((rememberMe && rememberMe[key] && rememberMe[key] === "false") ||
            (rememberMe && typeof rememberMe[key] === "undefined"))
        ) {
          store.commit("AUTH_LOGOUT_TEAM", key);
          store.commit("GLOBAL_RESET_GLOBAL_TEAM_SETTINGS", key);
        }
      }
    });
    if (rememberMe && teamUid && rememberMe[teamUid] && rememberMe[teamUid] === "true") {
      localSession ? (localSession[teamUid] = "true") : (localSession = { teamUid: true });
      localStorage.setItem("localStorageEnvivo", JSON.stringify(localSession));
    }
    console.log("***** DEBUG ***** teams", store.getters.auth_get_teams);
    console.log("***** DEBUG ***** session ...", session, localSession, rememberMe);
    console.log(
      "***** DEBUG ***** CHECK",
      session === null &&
        localSession === null &&
        ((rememberMe && teamUid && rememberMe[teamUid] && rememberMe[teamUid] === "false") ||
          (rememberMe && typeof rememberMe[teamUid] === "undefined"))
    );

    init(teamUid);
    // ### HANDLE AUTHENTICATION, ROUTING, REDIRECTS ###
    // check if authenticated for this team uid
    const authenticated = store.getters.auth_get_teams[teamUid]
      ? store.getters.auth_get_teams[teamUid].authenticated
      : false;
    console.log("### TEAMUID", teamUid, store.getters.auth_get_teams[teamUid]);
    console.log("### AUTHENTICATED", authenticated, teamUid, store.getters.auth_get_teams);
    console.log("### FROM: ", from, " TO: ", to);

    // if invalid route
    if (!to.name) {
      next("/notfound");
      store.commit("GLOBAL_RESET_LOADING_STATES");
    }
    // if not authenticated
    if (!authenticated && to.meta.requiresAuth) {
      console.log("***** NOT AUTHENTICATED BUT REQUIRED");
      console.log("SAVE REDIRECT ROUTE", to);
      store.dispatch("setRedirectRoute", to.fullPath);
      if (to.params.team) {
        console.log("***** TEAM PARAM EXISTS");
        if (store.getters.auth_get_teams[to.params.team]) {
          console.log(
            "***** TEAM EXISTS IN STORE, REDIRECT TO: /" + store.getters.auth_get_teams[to.params.team].team.slug
          );
          next("/" + store.getters.auth_get_teams[to.params.team].team.slug);
        } else {
          console.log("***** TEAM DOES NOT EXIST IN STORE, REDIRECT TO: /login");
          next("/login");
        }
      } else if (to.params.teamSlug) {
        console.log("***** TEAMSLUG PARAM EXISTS, REDIRECT TO: /" + to.params.teamSlug);
        next("/" + to.params.teamSlug);
      } else {
        console.log("***** NO PARAM EXISTS, REDIRECT TO: /");
        next("/");
      }
      store.commit("GLOBAL_RESET_LOADING_STATES");
    } else if (authenticated) {
      store.dispatch("getAuthAccount", { team: teamUid }).then(() => {
        document.title = store.getters.auth_get_teams[teamUid].team.name + " - envivo";
        Vue.prototype.$eventbus.$emit("setProfileDropdown", teamUid);
        Vue.prototype.$eventbus.$emit("initActivityRefresher", teamUid);
        Vue.prototype.$eventbus.$emit("getMessagesCounter");
        // if unsaved changes
        if (store.getters.global_get_teams_settings[teamUid].unsavedChanges) {
          const answer = window.confirm(i18n.t("app.confirmLeaving"));
          console.log("********* ANSWER", answer);
          if (!answer) {
            return next(false);
          } else {
            store.commit("GLOBAL_SET_UNSAVED_CHANGES", { val: false, team: teamUid });
          }
        }
        // if invalid subscription
        if (
          store.getters.auth_get_teams[teamUid] &&
          store.getters.auth_get_teams[teamUid].account.team.subscription === null &&
          to.name !== "TeamSubscription"
        ) {
          console.log("***** AUTHENTICATED BUT INVALID TEAM SUBSCRIPTION");
          Vue.prototype.$eventbus.$emit("initActivityRefresher", false);
          next("/t/" + teamUid + "/subscription");
        } else if (
          store.getters.auth_get_teams[teamUid] &&
          store.getters.auth_get_teams[teamUid].account.team.subscription !== null &&
          to.name === "TeamSubscription"
        ) {
          next("/t/" + teamUid + "/dashboard");
        } else if (!to.name && to.params.team) {
          console.log("***** AUTHENTICATED BUT INVALID URL");
          next("/t/" + teamUid + "/dashboard");
        } else if (to.name === "Login") {
          console.log("***** AUTHENTICATED, Login route redirect");
          next("/t/" + teamUid + "/dashboard");
        } else if (
          (to.name === "QuickLaunch" ||
            to.name === "QuickLaunchWithClient" ||
            to.name === "QuickLaunchWithClientAndProject") &&
          from.name !== "QuickLaunch" &&
          from.name !== "QuickLaunchWithClient" &&
          from.name !== "QuickLaunchWithClientAndProject"
        ) {
          console.log("***** AUTHENTICATED, before Quicklaunch store previous route");
          store.dispatch("setQuickLaunchRedirectRoute", from.path);
          next();
        } else if (store.getters.global_get_redirect_route) {
          console.log("***** AUTHENTICATED, REDIRECT EXISTS");
          next(store.getters.global_get_redirect_route);
          store.dispatch("setRedirectRoute", null);
        } else {
          console.log("***** AUTHENTICATED, CONTINUE", to.name);
          console.log("QUERY?", store.getters.global_get_start_query);
          if (teamUid && store.getters.global_get_start_query) {
            next({
              name: to.name,
              params: { team: teamUid },
              query: { start: store.getters.global_get_start_query },
            });
            store.commit("GLOBAL_SET_START_QUERY", null);
          } else {
            next();
          }
        }
        store.commit("GLOBAL_RESET_LOADING_STATES");
      });
    } else {
      console.log("***** DEFAULT", to.name);
      console.log("to, from, next", to, from);
      if (to.query && to.query.start) store.commit("GLOBAL_SET_START_QUERY", to.query.start);
      next();
      // Vue.prototype.$eventbus.$emit("initTeam");
      store.commit("GLOBAL_RESET_LOADING_STATES");
    }
  });
});

/* eslint-disable no-new */
new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n,
  envivo,
  components: { App },
}).$mount("#app");
